import { render, staticRenderFns } from "./DeleteEmitterDialog.vue?vue&type=template&id=da22fbcc"
import script from "./DeleteEmitterDialog.vue?vue&type=script&lang=js"
export * from "./DeleteEmitterDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteEmitterDialog.vue?vue&type=style&index=0&id=da22fbcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports